import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap } from 'rxjs';

import { CreateDialogService } from '../../services/create-dialog.service';

import { UniversalCreateActions } from './universal-create.actions';
import { selectUserDialogModePreference } from './universal-create.selectors';

@Injectable()
export class UniversalCreateEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private createDialogService = inject(CreateDialogService);

  openUniversalCreateDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UniversalCreateActions.open),
        concatLatestFrom(() => this.store.select(selectUserDialogModePreference)),
        switchMap(([{ data, mode }, userMode]) => this.createDialogService.open(data, mode || userMode))
      ),
    { dispatch: false }
  );
}
